import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PathLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { environment } from 'src/environments/default/environment';

import { GlobalHttpInterceptorService } from './interceptor/global-http-interceptor-service';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';

import { OrganizationModule } from './api/proxy/organization/organization.module';
import { MediaModule } from './api/proxy/media/media.module';
import { PractitionerModule } from './api/proxy/practitioner/practitioner.module';
import { AuthModule } from './api/proxy/auth/auth.module';
import { CalendarModule } from './api/proxy/calendar/calendar.module';
import { PathologyModule } from './api/proxy/pathology/pathology.module';
import { IVCSModule } from './api/proxy/ivcs/ivcs.module';
import { HealthFindrModule } from './api/proxy/healthFindr/health-findr.module';
import { ACSModule } from './api/proxy/acs/acs.module';
import { ConsultationModule } from './api/proxy/consultation/consultation.module';
import { MPIModule } from './api/proxy/mpi/mpi.module';
import { MDIModule } from './api/proxy/mdi/mdi.module';
import LightPreset from './styles/light-preset';
import { ProgressBarModule } from 'primeng/progressbar';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ProgressBarModule,
    CoreModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ToastModule,
    MPIModule.forRoot({ rootUrl: environment.mpiBaseUrl }),
    MDIModule.forRoot({ rootUrl: environment.mdiBaseUrl }),
    OrganizationModule.forRoot({ rootUrl: environment.organizationBaseUrl }),
    MediaModule.forRoot({ rootUrl: environment.mediaBaseUrl }),
    PractitionerModule.forRoot({ rootUrl: environment.practitionerBaseUrl }),
    AuthModule.forRoot({ rootUrl: environment.authBaseUrl }),
    CalendarModule.forRoot({ rootUrl: environment.calendarBaseUrl }),
    IVCSModule.forRoot({ rootUrl: environment.ivcsBaseUrl }),
    HealthFindrModule.forRoot({ rootUrl: environment.healthFindrBaseUrl }),
    PathologyModule.forRoot({ rootUrl: environment.pathologyBaseUrl }),
    ACSModule.forRoot({ rootUrl: environment.acsBaseUrl }),
    ConsultationModule.forRoot({ rootUrl: environment.consultationBaseUrl }),
  ],
  providers: [
    MessageService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: LightPreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
